<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="true" @openModalFilter="openModalFilter"></top-navbar>
  </keep-alive>
  <section id="claimDetailPage" class="container-content">

    <div class="accordion-block">
      <div class="accordion-block-item">
        <div class="accordion-block-header">
          <!-- Номер Заказа. При создании не заполняется. Заполняется при обмене с 1С из 1С -->
          <div class="container-acc-header">
            № 12345
          </div>
          <div class="container-acc-header">
            Дата создания: 
            <span class="order-color-date">01.03.2024</span>
          </div>
          <!-- При создании заказа Черновик -->
          <div class="container-acc-header">
            Статус: 
            <span class="draft">Новый</span>
          </div>
          <!-- При клике должен раскрываться календарь с отображением допустимых дат отгрузки. 
            Допустимый интервал отгрузки должен определяться по алгоритму 8.2 ТЗ -->
          <div class="container-acc-header">
            Дата рассмотрения: 
            <span class="order-color-date">01.03.2024</span>
          </div>
        </div>
        <!-- Блок для вывода уведомлений по Заказу. 
          В блок должны выводиться уведомления в процессе исполнения алгоритма расчета стоимости 
          (п. 8.1)  -->
        <div class="error-message">
          <!-- AAAAAAAAAAAAAAAAAAAa -->
        </div>
        <!-- Блок с общими данными по Заказу.  
        Детальная информация по блоку в разделе 6.3.3.5 -->
        <div class="accordion-block-content">
          <div class="row">
            <div class="col-12">
              <!-- Заполняется автоматически по карточке пользователя -->
              <div class="container-center">
                <div class="group-label-input">
                  <label>Наименование</label>
                  <input type="text">
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="container-center">
                <div class="group-label-input">
                  <label>Тип претензии</label>
                  <input type="text">
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <!-- Ручной ввод -->
              <div class="container-center">
                <div class="group-label-input">
                  <label>Номер заказа</label>
                  <input type="text">
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="container-center">
                <div class="group-label-input w-100">
                  <label>Описание</label>
                  <textarea name="text"></textarea>  
                </div>
              </div>

              <div class="btn btn-default btn-import">
                <mdicon name="file" width="18" height="16"></mdicon> Прикрепить файл
              </div>

              <div class="files-block">
                <div class="file-str">
                  <img src="@/assets/img/del-blue.svg">
                  Название файла.xlsx
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
export default {
  name: 'OrderCreatePage',
  components: {
    TopNavbar
  },
  data() {
    return {
      selectedGoods: [],
    }
  },
  mounted() {
  },
  watch: {
  },
  methods: {
  }
}
</script>
